const STORAGE_PREFIX = 'chatbot-bot-icon-local:';

function storageKey(domainName, botName, assetKey = 'botIconUrl') {
  return `${STORAGE_PREFIX}${domainName || 'unknown'}:${botName || 'unknown'}:${assetKey || 'botIconUrl'}`;
}

function legacyStorageKey(domainName, botName) {
  return `${STORAGE_PREFIX}${domainName || 'unknown'}:${botName || 'unknown'}`;
}

function safeJsonParse(raw) {
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function normalizeFileName(fileName) {
  if (typeof fileName !== 'string') return undefined;
  const trimmed = fileName.trim();
  return trimmed || undefined;
}

function normalizeEntry(entry) {
  if (!entry || typeof entry !== 'object') return null;
  const url = entry.url;
  if (typeof url !== 'string' || !url) return null;
  const normalized = {
    url,
    mimeType:
      typeof entry.mimeType === 'string' && entry.mimeType
        ? entry.mimeType
        : 'image/svg+xml',
  };
  const fileName = normalizeFileName(entry.fileName);
  if (fileName) {
    normalized.fileName = fileName;
  }
  return normalized;
}

export function loadLocalBotIcon(domainName, botName, assetKey = 'botIconUrl') {
  if (typeof localStorage === 'undefined') {
    return null;
  }

  const key = storageKey(domainName, botName, assetKey);
  let raw = localStorage.getItem(key);

  if (!raw && assetKey === 'botIconUrl') {
    raw = localStorage.getItem(legacyStorageKey(domainName, botName));
  }

  if (!raw) return null;

  const entry = safeJsonParse(raw);
  const normalized = normalizeEntry(entry);
  if (!normalized) {
    localStorage.removeItem(key);
    return null;
  }

  return normalized;
}

export function saveLocalBotIcon(domainName, botName, { url, mimeType, fileName }, assetKey = 'botIconUrl') {
  if (typeof localStorage === 'undefined') {
    return false;
  }

  if (typeof url !== 'string' || !url) {
    return false;
  }

  const key = storageKey(domainName, botName, assetKey);
  const nextEntry = {
    url,
    mimeType: mimeType || 'image/svg+xml',
    savedAt: new Date().toISOString(),
  };
  const normalizedFileName = normalizeFileName(fileName);
  if (normalizedFileName) {
    nextEntry.fileName = normalizedFileName;
  }

  try {
    localStorage.setItem(key, JSON.stringify(nextEntry));
    return true;
  } catch {
    return false;
  }
}

export function clearLocalBotIcon(domainName, botName, assetKey = 'botIconUrl') {
  if (typeof localStorage === 'undefined') {
    return;
  }

  localStorage.removeItem(storageKey(domainName, botName, assetKey));
  if (assetKey === 'botIconUrl') {
    localStorage.removeItem(legacyStorageKey(domainName, botName));
  }
}

export const ADMIN_IMAGE_ASSET_KEYS = [
  'botIconUrl',
  'subjectImageUrl',
  'subjectIconUrl',
];

export function clearAllLocalBotIcons(domainName, botName) {
  ADMIN_IMAGE_ASSET_KEYS.forEach((assetKey) => {
    clearLocalBotIcon(domainName, botName, assetKey);
  });
}
